// Stores the one-time recovery prompt marker in browser session storage.
export const RECOVERY_PROMPT_STORAGE_KEY = 'sportbook.auth.recoveryPrompt';

function hasSessionStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
}

export function markRecoveryPromptPending(): void {
  if (!hasSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(RECOVERY_PROMPT_STORAGE_KEY, '1');
}

export function consumeRecoveryPromptPending(): boolean {
  if (!hasSessionStorage()) {
    return false;
  }

  const isPending = window.sessionStorage.getItem(RECOVERY_PROMPT_STORAGE_KEY) === '1';
  if (isPending) {
    window.sessionStorage.removeItem(RECOVERY_PROMPT_STORAGE_KEY);
  }

  return isPending;
}

export function clearRecoveryPromptPending(): void {
  if (!hasSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(RECOVERY_PROMPT_STORAGE_KEY);
}
